module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"News":"Nachrichten","More News":"Weitere Nachrichten","Our products":"Unsere Produkte","Products text":"Eine Glasplatte kann mehrere Funktionen erfüllen.","More products":"Weitere Produkten","Designer":"Designer"},"en":{"News":"News","More News":"More news","Our products":"Our products","Products text":"A sheet of glass can fulfill multiple functions.","More products":"More products","Designer":"Designer"},"hu":{"News":"Híreink","More News":"További hírek","Our products":"Termékeink","Products text":"Egy üveglap több funkciót is betölthet.","More products":"További termékek","Designer":"Tervező"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Home.vue
// module id = 368
// module chunks = 0